"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProseList = exports.Prose = void 0;
var prose_1 = require("./prose");
Object.defineProperty(exports, "Prose", { enumerable: true, get: function () { return __importDefault(prose_1).default; } });
var prose_list_1 = require("./prose.list");
Object.defineProperty(exports, "ProseList", { enumerable: true, get: function () { return __importDefault(prose_list_1).default; } });
//# sourceMappingURL=index.js.map